// extracted by mini-css-extract-plugin
export default {"RemainingTime":"RemainingTime_RemainingTime__Ggzlg","coverImage":"RemainingTime_coverImage__vWie7","image":"RemainingTime_image__m9YmD"};